import { SURVEY_FILTER_TYPE } from './dashboard-filtering.constants';
import { FilterDetails, FilterField, FilterType } from './types';

export class DashboardFilter {
  protected constructor(
    public readonly field: FilterField,
    public readonly type: FilterType,
    protected readonly _values: string[],
    public readonly options: string[] = []
  ) {}

  public static create(
    data: FilterDetails,
    values: string[] = []
  ): DashboardFilter {
    const filteredValues = values.filter((value) => value !== '');
    return new DashboardFilter(
      data.field,
      data.type,
      filteredValues,
      data.options
    );
  }

  public applicable(): boolean {
    if (this._values.length === 0) {
      return false;
    }

    if (this.type === SURVEY_FILTER_TYPE.MULTI_OPTION) {
      // if all options are selected, the filter is not applicable
      return (
        this.options.length === 0 || this._values.length < this.options.length
      );
    }

    return this._values.length === 1;
  }

  public values(): string[] {
    if (this.applicable()) {
      return this._format(this._values);
    }

    return [];
  }

  private _format(values: string[]): string[] {
    if (this.type === SURVEY_FILTER_TYPE.SEARCH) {
      return values;
    }

    // replace all spaces with _
    return values.map((value) =>
      String(value).toLowerCase().replace(/ /g, '_')
    );
  }
}
